module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/sec02_2_sp_6b44e999c176df5c396ff379915d1b36.jpg";